import { Fragment } from 'react';

import {
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonThumbnail
} from '@ionic/react';

import styles from './TeammateList.module.scss';

import { Service } from '../../services/service';
import { Teammate } from '../../types/services.types';
import { Image } from '../Image/Image';
import { TeammateRow } from '../TeammateRow/TeammateRow';

export interface TeammateListProps {
  name: string;
  onInviteClicked: (email: string) => Promise<void>;
  photoUrl: string;
  service: Service;
  teammates: Teammate[];
  token?: string;
}

export const TeammateList = ({
  photoUrl,
  name,
  teammates,
  service,
  token,
  onInviteClicked
}: TeammateListProps) => (
  <IonItemGroup>
    <IonItemDivider color="light">
      <IonThumbnail slot="start" className={styles.avatar}>
        <Image service={service} url={photoUrl} token={token} />
      </IonThumbnail>
      {name}
    </IonItemDivider>
    {teammates.length && token ? (
      <div className={styles.teammates}>
        {teammates.map((teammate) => (
          <Fragment key={`teammate-${teammate.id}`}>
            <TeammateRow
              service={service}
              token={token}
              teammate={teammate}
              sendTeammateInvite={onInviteClicked}
            />
          </Fragment>
        ))}
      </div>
    ) : (
      <div className={styles.empty}>
        <IonLabel>No teammates found in {name}</IonLabel>
      </div>
    )}
  </IonItemGroup>
);
